import { getGatewayBaseUrl } from "../config";
import { PosMemberSignupGatewayClient } from "../gateway/member-signup-client";
import { upsertLocalMemberRuntime } from "./member-runtime";
import type { TrustedTerminalIdentity } from "./terminal-state";

export async function signupPosMember(input: {
  identity: TrustedTerminalIdentity;
  deviceSecret: string;
  sessionToken: string;
  nickname: string;
  phone: string;
  termsAccepted: boolean;
  requestKey: string;
}) {
  const baseUrl = getGatewayBaseUrl();
  if (!baseUrl) throw new Error("POS_GATEWAY_NOT_CONFIGURED");

  const client = new PosMemberSignupGatewayClient({ baseUrl });
  const result = await client.signup({
    deviceSecret: input.deviceSecret,
    sessionToken: input.sessionToken,
    nickname: input.nickname,
    phone: input.phone,
    termsAccepted: input.termsAccepted,
    requestKey: input.requestKey,
  });
  if (!result.ok || !result.data?.member) {
    throw new Error(result.error ?? "CUSTOMER_MEMBER_POS_SIGNUP_FAILED");
  }

  const member = await upsertLocalMemberRuntime(input.identity, result.data.member);
  if (!member) throw new Error("CUSTOMER_MEMBER_POS_SIGNUP_READBACK_INVALID");
  return { member, resultStatus: result.data.result_status };
}
